export default __webpack_public_path__ + "c13fb8826d3d815fdb4e3d60b8906a5a.svg";